import request from "@/hooks/useRequest";
import {
  POSTPAYMENTPASSWORDVERIFY,
  POSTGASECRET,
  POSTVALIDATIONITEMS,
  POSTGABIND,
  POSTLOGINVERIFYPAYMENTPASSWORD,
} from "@/helpers/constants/requestApi";

//邮箱验证
export const postPaymentPwdVerify = (body) => {
  return request(POSTPAYMENTPASSWORDVERIFY, { body });
};

//生成ga秘钥
export const postCreateGaSecret = (body) => {
  return request(POSTGASECRET, { body });
};

//需要的安全要素
export const postValidationItemFunc = (body) => {
  return request(POSTVALIDATIONITEMS, { body });
};

// //绑定ga
export const postGaBind = (body) => {
  return request(POSTGABIND, { body });
};

// 未登录校验支付密码（登录流程）
export const postVerifyPaymentPasssword = (body) => {
  return request(POSTLOGINVERIFYPAYMENTPASSWORD, { body });
};
